import { type IBucket, IBucketID } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';

const result: IBucket = {
  id: IBucketID.SCALING,
  settings: {
    automaticDowngradeTier: {
      venue: PremiumTiers.Unverified,
      suppliers: PremiumTiers.Unverified,
    },
    weddingFairs: {
      venue: {
        [PremiumTiers.Unverified]: 1,
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_0_5]: 1,
        [PremiumTiers.Tier_1]: 1,
        [PremiumTiers.Tier_2]: 1,
        [PremiumTiers.Tier_2_5]: 2,
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: 4,
      },
      types: {
        excluded: ['group'],
      },
    },
    templatedResponses: {
      venue: {
        [PremiumTiers.Unverified]: 1,
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_0_5]: 1,
        [PremiumTiers.Tier_1]: 2,
        [PremiumTiers.Tier_2]: 2,
        [PremiumTiers.Tier_2_5]: 4,
        [PremiumTiers.Tier_3]: 6,
        [PremiumTiers.Tier_4]: Infinity,
      },
      suppliers: {
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_1]: 2,
        [PremiumTiers.Tier_2]: 4,
      },
    },
    autoFollowUpTemplatedResponses: {
      venue: {
        [PremiumTiers.Tier_2_5]: 1,
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: Infinity,
      },
      suppliers: {
        [PremiumTiers.Tier_1]: 2,
        [PremiumTiers.Tier_2]: 4,
      },
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
    },
    badges: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    instagramIntegration: {
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_3,
        },
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    realWeddings: {
      tier: {
        minimum: PremiumTiers.Tier_0,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    realWeddingsCarousel: true,
    trendingCarouselSuppliers: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    topSpot: {
      waitlist: true,
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      types: {
        included: ['venue'],
      },
    },
    roiSummary: null,
    couplesIntel: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    lostLeadsStats: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      types: {
        included: ['venue'],
      },
    },
    lostLeadTracking: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      venue: 5,
    },
    yourCompetitors: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    multiCounty: {
      venue: {
        [PremiumTiers.Tier_3]: 5,
        [PremiumTiers.Tier_4]: 5,
      },
      suppliers: {
        [PremiumTiers.Tier_2]: 2,
      },
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_3,
        },
      },
    },
    venueTypeHero: {
      waitlist: true,
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    couplesActivity: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_0,
        },
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    contactCouples: {
      venue: {
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: 6,
      },
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_3,
        },
      },
      suppliers: {
        [PremiumTiers.Tier_2]: 4,
      },
    },
    lostLeadsInsightsEnquirySource: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    revealCoupleEmailAddress: {
      tier: {
        minimum: PremiumTiers.Tier_0,
        minimumByType: {
          venue: PremiumTiers.Tier_1,
        },
      },
      types: {
        excluded: ['group'],
      },
    },
    revealCouplePhoneNumber: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_0_5,
        },
      },
      types: {
        excluded: ['group'],
      },
    },
    coupleTargeting: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2,
        },
      },
      types: {
        excluded: ['group'],
      },
    },
    coupleTargetingGuestCount: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      types: {
        included: '*',
      },
    },
    lateAvailability: {
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      venue: {
        [PremiumTiers.Tier_2_5]: 4,
        [PremiumTiers.Tier_3]: 8,
        [PremiumTiers.Tier_4]: Infinity,
      },
      suppliers: {
        [PremiumTiers.Tier_2]: 4,
      },
    },
    deals: {
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    bridebookDiscounts: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        excluded: ['group'],
      },
    },
    videoTours: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        excluded: ['group'],
      },
    },
    professionalNetwork: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['suppliers'],
      },
    },
    specialOfferRecommendation: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['venue'],
      },
    },
    couplesInsightsSearchAppearances: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_0,
        },
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    couplesInsightsProfileViews: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_1,
        },
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    couplesInsightsEnquiries: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_0,
        },
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    searchPerformance: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        excluded: ['group'],
      },
    },
    socialMediaSupport: null,
    marketInsightsStats: null,
    marketInsightsStatsCoupleBudget: null,
    bridebookInstitute: null,
    upgradePlan: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        excluded: ['group'],
      },
    },
    weddingReports: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['suppliers'],
      },
    },
    featureTutorials: null,
    searchOptimisation: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2,
        },
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    searchBoost: null,
    chargebeePricingTable: null,
    adminBanners: true,
    messageCenter: {
      types: {
        excluded: ['group'],
      },
    },
    businessSelfSignUp: true,
    aboutYou: {
      types: {
        included: ['suppliers'],
      },
    },
    countyDropdown: true,
    searchPresets: null,
    smartEmails: null,
    locations: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['suppliers'],
      },
    },
    onboardingConciergeFlow: true,
    enquiryWidget: {
      types: {
        included: ['venue'],
      },
    },
    welcomeMessage: {
      types: {
        included: ['venue'],
      },
    },
    trends: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    historicalSearchPositionChart: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    keepRelationsOnTierDowngrade: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    replyToReviews: {
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      types: {
        excluded: ['group'],
      },
    },
    inspirationAndAdvice: true,
    specialOffersCarousel: true,
    rapidResponder: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    featuredSupplierMarker: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2,
        },
      },
    },
    youMayAlsoLikeCarousel: {
      venue: [PremiumTiers.Unverified],
    },
    couplesAlsoLikeCarousel: {
      venue: [PremiumTiers.Tier_0, PremiumTiers.Tier_1],
    },
    additionalImageOnSearch: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
    },
    quickFiltersPill: {
      venue: ['exclusiveUse', 'weddingLicence', 'hasLateAvailability'],
      photo: ['videographyAvailable'],
      music: ['dj', 'ensembleGroup', 'soloMusician'],
      catering: ['staffProvided', 'tablewareProvided'],
    },
    quickFiltersDropdown: {
      venue: ['price', 'guests', 'upcomingEvents', 'venueType', 'noOfBedrooms'],
      photo: ['photographyStyle'],
      music: ['musicStyle'],
      catering: ['foodType', 'dietaryOptions'],
    },
    recommendedSuppliersCarousel: null,
    recommendations: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    hideLimitedProfiles: null,
    hasEssentials: null,
    smartPricing: null,
    mandatoryOnboardingPhoneNumber: null,
    freeTrial: {
      suppliers: {
        tier: PremiumTiers.Tier_1,
        days: 90,
        activation: 'signup',
      },
    },
    profileHighlightsSection: {
      types: {
        included: ['venue', 'photo'],
      },
    },
    seoScoreBoost: {
      tiers: {
        [PremiumTiers.Tier_1]: 1,
        [PremiumTiers.Tier_2]: 2,
      },
      types: {
        excluded: ['venue'],
      },
    },
    searchFilters: {
      venue: {
        priceSection: [
          'pricingAffordable',
          'pricingModerate',
          'pricingLuxury',
          'pricingSuperLuxury',
        ],
        guestsSection: true,
        overviewSection: [
          'highestReviewed',
          'exclusiveUse',
          'hasAccommodation',
          'lateNightExtensionAvailable',
          'alcoholLicense',
        ],
        distanceSection: true,
        upcomingEvents: ['hasShowroundViewingDatesAvailable', 'hasWeddingFairOrOpenDay'],
        accommodationRoomsSection: true,
        venueType: [
          'countryHouseManorHouse',
          'barn',
          'gardenOutdoor',
          'statelyHome',
          'castle',
          'hotel',
          'cityHotelCityVenue',
          'warehouseFactory',
          'museumAttraction',
          'uniqueVenueType',
          'pubRestaurant',
          'golfCourse',
          'cruiseBoatYacht',
          'sportingVenueStadium',
          'conferenceCentre',
          'placeOfWorship',
          'townHallRegistryOffice',
          'otherVenueType',
          'winery',
        ],
        venueStyle: [
          'classic',
          'intimate',
          'alternative',
          'romantic',
          'lovelyGrounds',
          'unusual',
          'affordable',
          'outdoor',
          'luxury',
          'rustic',
          'beach',
          'modern',
          'unique',
          'urban',
          'blankCanvas',
          'greatViews',
          'historic',
          'asian',
          'casual',
          'formal',
          'stylish',
        ],
        venueFeatures: [
          'onsiteParking',
          'disabledAccess',
          'inHouseWeddingCoordinator',
          'inHouseDancefloor',
          'soundSystemAvailable',
          'ballroom',
          'confettiPermitted',
          'fireworksPermitted',
          'marqueePermitted',
          'waterView',
          'landscapedGardens',
          'petFriendly',
          'churchWithinWalkingDistance',
          'transportation',
          'wifi',
        ],
        foodDrinkSection: [
          'inHouseCatering',
          'externalCateringPermitted',
          'kosherCatering',
          'halalCatering',
          'asianCatering',
          'byobPermitted',
          'vegan',
        ],
        specialOffers: ['hasDiscounts', 'hasBridebookOffer', 'hasGift', 'hasLateAvailability'],
        specialistWeddingSection: [
          'asianWeddingSpecialist',
          'jewishWeddingSpecialist',
          'muslimWeddingSpecialist',
          'otherWeddingSpecialist',
        ],
        diversityAndInclusion: ['inclusivityLgbtqPlusExpert', 'inclusivityNeurodiverseFriendly'],
      },
    },
    forcedCuratedListSearch: null,
    upcomingShowroundsWidget: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    aiWeddingPlanner: null,
  },
};

export default {
  [result.id]: result,
};
